import Controller from '@ember/controller';
import { service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import DepartmentModel from 'scaleflow/models/department';

type Tab = {
  label: string;
  route: string;
  key: string;
};

export default class CompanyDepartmentController extends Controller {
  @service declare intl: IntlService;
  declare model: DepartmentModel;

  get team() {
    return this.model;
  }

  get tabs(): Tab[] {
    const tabs = [
      {
        label: 'Home',
        route: 'departments.department.home',
        key: 'home',
      },
      {
        label: 'Goals',
        route: 'departments.department.goals',
        key: 'goals',
      },
      {
        label: 'Roadmap',
        route: 'departments.department.roadmap',
        key: 'roadmap',
      },
      {
        label: 'Initiatives',
        route: 'departments.department.initiatives',
        key: 'initiatives',
      },
      {
        label: 'Settings',
        route: 'departments.department.settings',
        key: 'settings',
      },
    ];
    return tabs;
  }
}
